<template>
  <v-container>
    <v-row class="container1" v-if="affiliate" :class="[getThemeColor, $vuetify.breakpoint.xs?'flex-column':'']">
      <v-col v-if="!$vuetify.breakpoint.xs" class="pa-8" sm="8" style="margin-top:5%;position:relative;">
        <div style="margin-top: 5%;padding-top:80%;position: relative;">
          <div class="gallery" id="affiliate-carousel">
            <v-row style="margin-top:20px;padding-top: 62%;position:relative;">
              <VueSlickCarousel v-bind="cc" style="position:absolute;top:0;height: 100%;left:0;right:0;">
                <div
                  v-for="photo in affiliate.slider"
                  :key="photo.id"
                >
                  <v-img
                    height="100%"
                    :src="ip+photo.url"
                  />
                </div>
              </VueSlickCarousel>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col class="pa-0" v-if="$vuetify.breakpoint.xs" col="12" style="position:relative;">
        <div id="affiliate-carousel">
            <VueSlickCarousel v-bind="cc" style="width:100%;">
              <div
                v-for="photo in affiliate.slider"
                :key="photo.id"
              >
                <v-img
                  height="100%"
                  :src="ip+photo.url"
                />
              </div>
            </VueSlickCarousel>
        </div>
      </v-col>
      <v-col :class="!$vuetify.breakpoint.xs?'pa-10':'pa-0'" sm="4" col="12">
        <img 
          v-if="!$vuetify.breakpoint.xs"
          :src="ip+affiliate.logo.url"
          contain
          style="margin: auto;margin-bottom:40px;max-width: 200px;"
          data-aos="custom-fade" data-aos-delay="500" data-aos-duration="2000"
        />
        <div v-if="!$vuetify.breakpoint.xs" style="position:relative;overflow: hidden;width:80%;margin: auto;">
          <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
          <div style="opacity: 0;cursor:default" :class="$i18n.locale=='en'?'georgia font-size-s4':'NotoSerifTC font-size-s4-chi'" class="store-name">{{affiliate.name[$i18n.locale]}}</div>
          <div data-aos-easing="ease" :class="$i18n.locale=='en'?'georgia font-size-s4':'NotoSerifTC font-size-s4-chi'" data-aos="custom-title-fade-in" data-aos-duration="1000" data-aos-delay="1000" class="store-name" >{{affiliate.name[$i18n.locale]}}</div>
          <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
        </div>
        <v-row v-if="$vuetify.breakpoint.xs" class="flex-row" style="padding: 0px 28px;">
          <v-col col=6>
            <img 
              :src="ip+affiliate.logo.url"
              contain
              style="width:90%;"
              data-aos="custom-fade" data-aos-delay="500" data-aos-duration="2000"
            />
          </v-col>
          <v-col col=6 class="pa-0" style="display:flex;align-items:center;">
            <div style="position:relative;overflow: hidden;width:100%;margin: auto;">
              <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
              <div style="opacity: 0;cursor:default" :class="$i18n.locale=='en'?'georgia font-size-s4':'NotoSerifTC'" class="store-name">{{affiliate.name[$i18n.locale]}}</div>
              <div data-aos-easing="ease" :class="$i18n.locale=='en'?'georgia font-size-s4':'NotoSerifTC'" data-aos="custom-title-fade-in" data-aos-duration="1000" data-aos-delay="1000" class="store-name" >{{affiliate.name[$i18n.locale]}}</div>
              <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
            </div>
          </v-col>
        </v-row>
        <!-- <v-divider data-aos="custom-fade" data-aos-duration="3000" class="title-top-line"></v-divider>
        <div class="store-name showupfp storenamesize" style="margin:15px;" data-aos="custom-fade" data-aos-duration="3000">{{affiliate.display_name_english}}</div>
        <v-divider data-aos="custom-fade" data-aos-duration="3000" class="title-bottom-line"></v-divider> -->
        <div class="company-detail description-size" style="margin-top:30px;" :class="getThemeColor" v-if="affiliate.display_description_english" data-aos="custom-fade" data-aos-duration="3000">
          <div class="company-detail">{{affiliate.description[$i18n.locale]}}</div>
        </div>
        <div class="store-address" v-if="affiliate.display_description_english">
          <v-divider data-aos="custom-fade" data-aos-duration="3000" style="border-color: white;width:15%;margin: auto;"></v-divider>
        </div>
        <div 
          v-for="address in affiliate.stores"
          :key="address.id"
        >
          <div class="store-address description-size" :class="getThemeColor" data-aos="custom-fade" data-aos-duration="3000">
            <div :class="$i18n.locale=='en'?'DinCondL font-size-s1 mobileaddresspadding':'MHeiHK fontsizeaffiliateaddress-chi'" class="address-info" v-on:click="openDialog(address)">
              {{address.address_row1[$i18n.locale]}}<br>
              {{address.address_row2[$i18n.locale]}}
            </div>
            <div :class="$i18n.locale=='en'?'DinCondL font-size-s1 mobileaddresspadding':'MHeiHK fontsizeaffiliateaddress-chi'"  class="address-info-tel" v-html="$t('affiliate.telephone',{telephone: address.display_address_telephone})"></div>
            <div :class="$i18n.locale=='en'?'DinCondL font-size-s1 mobileaddresspadding':'MHeiHK fontsizeaffiliateaddress-chi'"  class="address-info" v-if="address.email"><a class="mailto" :href="'mailto:'+address.email">{{$t('affiliate.email',{email: address.email})}}</a></div>
          </div>
        </div>
        <div v-if="affiliate.stores.length" class="store-address">
          <v-divider data-aos="custom-fade" data-aos-duration="3000" style="border-color: white;width:15%;margin: auto;"></v-divider>
        </div>
        <v-row :class="getThemeColor" style="margin-top:20px">
          <v-col sm=12 v-if="affiliate.facebook" v-on:click="goto(affiliate.facebook_link)" :class="$i18n.locale=='en'?'DinCondL font-size-s1':'MHeiHK fontsizeaffiliateaddress-chi'" class="social-media-info d-flex align-center justify-center"><v-icon class="icon">fab fa-facebook-square</v-icon><span>{{affiliate.facebook}}</span></v-col>
          <v-col sm=12 v-if="affiliate.instagram" v-on:click="goto(affiliate.instagram_link)" :class="$i18n.locale=='en'?'DinCondL font-size-s1':'MHeiHK fontsizeaffiliateaddress-chi'" class="social-media-info d-flex align-center justify-center"><v-icon class="icon">fab fa-instagram</v-icon><span>{{affiliate.instagram}}</span></v-col>
          <v-col sm=12 v-if="affiliate.sina" v-on:click="goto(affiliate.sina_link)" :class="$i18n.locale=='en'?'DinCondL font-size-s1':'MHeiHK fontsizeaffiliateaddress-chi'" class="social-media-info d-flex align-center justify-center weibo_font_size"><v-icon class="icon">fab fa-weibo</v-icon><span>{{affiliate.sina}}</span></v-col>
          <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-delay="1000"></div>
        </v-row>
        <v-row :class="getThemeColor" style="margin-top:20px" v-if="affiliate.EventPhotos.length || affiliate.VideoRecipes.length"> 
          <router-link :to="'/affiliate/'+affiliate_id+'/gallery'" style="margin: auto;" v-if="affiliate.EventPhotos.length">
            <div :class="$i18n.locale=='en'?'DinCondL font-size-s5':'MHeiHK font-size-s5-chi'" class="button" style="float:left;margin-left: auto;"><span style="padding-right:10px" v-html="$t('affiliate.event_photos')"></span>
            <simple-line-icons
              icon="arrow-right"
              size="small"
              class="siis"
              no-svg
            /></div>
          </router-link>
          <router-link :to="'/affiliate/'+affiliate_id+'/recipes'" style="margin: auto;" v-if="affiliate.VideoRecipes.length">
            <div :class="$i18n.locale=='en'?'DinCondL font-size-s5':'MHeiHK'" class="button" style="float:left;margin-left: auto;"><span style="padding-right:10px" v-html="$t('affiliate.event_photos')"></span>
            <simple-line-icons
              icon="arrow-right"
              size="small"
              class="siis"
              no-svg
            /></div>
          </router-link>
          <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000" data-aos-delay="1000"></div>
        </v-row>
      </v-col>
    </v-row>
    <div class="custom-dialog" :class="dialog?'custom-dialog-show':''" v-if="address">
      <div class="overlay" @click.self.stop="dialog = false;photoIndex=0;">
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.9;"></div>
            <v-row class="ma-0 pa-3">
              <v-icon @click="dialog = false;photoIndex=0;" style="cursor:pointer;color:black;margin-left: auto;" size=36>mdi-close</v-icon>
            </v-row>
            <div class="pa-0 inner-dialog">
              <v-row style="z-index:0;padding-top:60%;margin:auto;position:relative;">             
                <GmapMap
                  :center="{lat:Number(address.map_latitude), lng:Number(address.map_longitude)}"
                  :zoom="17"
                  map-type-id="roadmap"
                  style="z-index:5;position:absolute;height:100%;width:100%;top:0;left:0;"
                  :options="mapStyle"
                >
                  <GmapMarker
                    :position="{lat:Number(address.map_latitude), lng:Number(address.map_longitude)}"
                  />
                </GmapMap>
              </v-row>
              <v-row :class="$i18n.locale=='en'?'DinCondL font-size-s1':'MHeiHK fontsizeaffiliateaddress-chi'" style="z-index:0;margin:auto;position:relative;padding-left:0;">    
                <span style="color: #132b1b;float: left;">{{address.address_row1[$i18n.locale]}}</span>
                <span style="color: #132b1b;float: left;margin-left: 4px;">{{address.address_row2[$i18n.locale]}}</span>  
                <span style="color: #132b1b;float: left;margin-left: 10px;">{{address.display_address_telephone}}</span>    
              </v-row>
            </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import axios from 'axios';
var ip = "https://lorencegroup.com/api";
export default {
  name: 'AffiliateInfo',
  components: {
    VueSlickCarousel
  },
  data:  () => ({
    "cc": {
      "arrows": false,
      "dots": true,
      "fade": true,
      "infinite": true,
      "slidesToShow": 1,
      "slidesToScroll": 1,

      "autoplay": true,
      "autoplaySpeed": 4000,
      "speed": 1000,
      "pauseOnDotsHover": true,
      "pauseOnFocus": true,
      "pauseOnHover": true,
    },
    dialog: false,
    address: null,
    affiliate: null,
    ip: ip,
    affiliate_id: null,
    mapStyle: {
      styles:[{
        stylers: [{
          saturation: -100
        }]
      }]}
  }),
  methods: {
    goto: function(url){
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    openDialog(address){
      this.dialog = true;
      this.address = address;
    },
  },
  mounted () {
    this.affiliate_id = this.$router.history.current.params.affiliate_id
    axios.get(ip+"/affiliates/"+this.$router.history.current.params.affiliate_id)
    .then(response => {
      this.affiliate=response.data;
      this.affiliate.name=[]
      this.affiliate.name["en"] = this.affiliate.display_name_english;
      this.affiliate.name["zh_TW"] = this.affiliate.display_name_trad_chinese;
      this.affiliate.description=[]
      if(this.affiliate.display_description_english){
        this.affiliate.description["en"] = this.affiliate.display_description_english;
      }
      if(this.affiliate.display_description_trad_chinese){
        this.affiliate.description["zh_TW"] = this.affiliate.display_description_trad_chinese;
      }
      if(this.affiliate.stores){
        this.affiliate.stores.forEach(store => {
          store.address_row1 = []
          store.address_row2 = []
          store.address_row1["en"] = store.display_address_row1_english
          store.address_row2["en"] = store.display_address_row2_english
          store.address_row1["zh_TW"] = store.display_address_row1_trad_chinese
          store.address_row2["zh_TW"] = store.display_address_row2_trad_chinese
        });
      }
      console.log(this.affiliate)
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  computed: {
    getThemeColor: function(){
      return {
        'black-theme': this.affiliate.theme=='black',
        'green-theme': this.affiliate.theme=='green'
      }
    },
  }
}
</script>

<style scoped>
.container1{
  padding:30px;
  height: 100%;
}

.custom-dialog{
  overflow-y: scroll;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.custom-dialog-show{
  z-index: 1;
}
.custom-dialog .overlay{
  height: 100%;
  width: 100%;
}
.custom-dialog .main-dialog{
  position: relative;
  width: 70%;
  margin: auto;
}
.mobile .custom-dialog .main-dialog{
  position: relative;
  width: 100%;
  height: 100%;
  margin: auto;
}


.custom-dialog .main-dialog span{
  color: #132b1b;
}

.custom-dialog .main-dialog .special-text{
  color: mediumseagreen;
  z-index: 0;
}

@media (min-width: 375px) { 
  .mobileaddresspadding {
    padding-top:5px;
  }

  .description-size {
    font-size:14px;
    padding-bottom:10px;
    padding-top:10px;
  }
}


@media (min-width: 768px) { 
  .custom-dialog .main-dialog{
    width: 100%;
    top: 50px;
    max-width: 800px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 992px) { 
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 900px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1264px) {
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 1100px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1904px) { 
  .custom-dialog .main-dialog{
    width: 70%;
    top: 50px;
    max-width: 1300px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}

.store-name{
  color:white;
  margin:auto;
  cursor: default;
  text-transform: uppercase;
  letter-spacing: 5px;
  padding: 15px;
  margin-top:8px;
  margin-bottom:8px;
}
.mobile .store-name{
  color:white;
  margin:auto;
  letter-spacing: 1px;
  cursor: default;
  text-transform: uppercase;
  padding: 2px;
  margin-top:5px;
  margin-bottom:5px;
}
.container1 .address{
  margin: auto;
  justify-content: center;
}
.address-info{
  color: white;
}
.address-info-tel{
  color: white;
  cursor: default;
}

.address-info:hover
{
  cursor: pointer;
  color:mediumseagreen;
}
.social-media-info{
  font-family:'DinCondL' ;
  color: white;
  letter-spacing: 2px;
}

.social-media-info .icon{
  color: white;
  padding:8px;
}

.social-media-info:hover{
  cursor: pointer;
  color:mediumseagreen;
}

.social-media-info:hover .icon{
  cursor: pointer;
  color:mediumseagreen;
}

.store-address{
  position: relative;
  font-family:'DinCondL' ;
  margin-top: 20px;
  letter-spacing: 1px;
}
.mobile .store-address{
  position: relative;
  font-family:'DinCondL' ;
  margin-top: 1px;
  letter-spacing: 1px;
  line-height:1;
}

.button{
  margin: auto;
  padding: 5px 10px;
  color:mediumseagreen;
  border: mediumseagreen solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer;
}

.button:hover{
  color:white;
  background: mediumseagreen;
  border: mediumseagreen solid 1px;
}

@media (min-width: 992px) { 
 .storenamesize {
    font-size:20px;
  }
}

@media (min-width: 1264px) { 
  .storenamesize {
    font-size:23px;
  }
}

@media (min-width: 1904px){
  .storenamesize {
    font-size:26px;
  }
}

@media (min-width: 992px) { 
 .description-size {
    font-size:15px;
  }

  .weibo_font_size{
    font-size:11px;
  }
}

@media (min-width: 1264px) { 
  .description-size {
    font-size:17px;
  }

  .weibo_font_size{
    font-size:13px;
  }
}

@media (min-width: 1904px){
  .description-size {
    font-size:20px;
  }

  .weibo_font_size{
    font-size:16px;
  }
}

.showupfp{
  animation: 1s ease-in 0s 1 showup-show;
}

.company-detail{
  color: white;
  letter-spacing: 1px;
  cursor: default;
}

.showfromtop{
  transition-delay: 2.2s;
}

@keyframes showup-show {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.container{
  padding-bottom: 0;
}
.gallery{
  position:absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
}

.title-top-line{
  border-color: grey; 
  margin-top:40px; 
  max-width:90%; 
  margin-left:auto; 
  margin-right:auto;
}

.title-bottom-line{
  border-color: grey; 
  margin-top:10px; 
  max-width:90%; 
  margin-left:auto; 
  margin-right:auto;
}
</style>